import { Component } from '@angular/core';
import { EasyTradingMatrixComponent } from '@zero/trading-tools/feature-easy-trading-matrix/web';

@Component({
  imports: [EasyTradingMatrixComponent],
  templateUrl: './trading-tools.component.html',
})
export class TradingToolsComponent {}
